import { render, staticRenderFns } from "./raisedFreightAndVendorDetails.vue?vue&type=template&id=7966f17c&scoped=true"
import script from "./raisedFreightAndVendorDetails.vue?vue&type=script&lang=js"
export * from "./raisedFreightAndVendorDetails.vue?vue&type=script&lang=js"
import style0 from "./raisedFreightAndVendorDetails.vue?vue&type=style&index=0&id=7966f17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7966f17c",
  null
  
)

export default component.exports